import { type BoardTaskStatus } from '../../../../../common/types/task';
import { type BoardTasksState } from '../tasksSlice';

export const addToStatus = (
  idsByStatus: BoardTasksState['idsByStatus'],
  status: BoardTaskStatus,
  id: number,
  insertMode: 'push' | 'unshift' = 'push'
) => {
  const list = idsByStatus[status];

  if (list.includes(id)) return;

  insertMode === 'unshift' ? list.unshift(id) : list.push(id);
};
